import GraphContent from "../graph_content";
import axios from "axios";
import { RequestParamsMaker } from "./make_request_params";

const setDisplay = (self: GraphContent) => {
  self.displayUnconfirmedAlert = Object.assign([], self.unconfirmedAlert);
  self.displayUnconfirmedAlert.reverse();
  self.displayAlertHistory = Object.assign([], self.alertHistory);
  self.displayAlertHistory.reverse();
};

const clearUnconfirmAlert = (self: GraphContent) => {
  self.unconfirmedAlert.length = 0;
};

export async function clearUnconfirmedAlert(self: GraphContent) {
  try {
    self.alertHistory = self.alertHistory.concat(self.unconfirmedAlert);
    clearUnconfirmAlert(self);
    setDisplay(self);
    const requestParams = RequestParamsMaker.makeClearUnconfirmedAlert(self);
    await axios(requestParams);
  } catch (e) {
    console.error(e);
  }
}
